/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { trackRudderstackImageEdited } from "common/utils/rudderstack/tracker.react";
import debounce from "lodash.debounce";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import RedrawNotes from "./RedrawNotes.vue";
import { useDtfStore } from "./store";
import TrimInfo from "./TrimInfo.vue";
import { cn } from "tailwind-variants";
import "./ArtworkQualityConfigPanel.scss";

export default function ArtworkQualityConfigPanel({
  artwork = null,
  index = 0,
  activeConfigSection = null,
  onSetActiveConfigSection,
  ...restProps
}: any) {
  const store = useDtfStore();

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  function isPrintAsUploadedDisabled() {
    return isStandardArtwork() && (artwork?.isLoading || !artwork?.enhancementCompleted);
  }

  function showRedrawNote() {
    // @ts-expect-error TS(4111): Property 'showRedrawUI' comes from an index signat... Remove this comment to see the full error message
    return store.showRedrawUI;
  }

  const debouncedToggleEnhancement = debounce(async (artworkId, enableEnhancement) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    await store.updateEnableEnhancement({
      artworkId,
      enableEnhancement
    });
  }, 100);

  function setActiveConfigSection(section: any) {
    if (section === "print-as-uploaded" && isPrintAsUploadedDisabled()) {
      return;
    }
    if (artwork?.pinningSessionId) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.setPendingPinningInvalidation({
        type: "enableEnhancement",
        artworkId: artwork.id,
        value: section === "jiffy-print-perfect",
        section
      });
      return;
    }
    onSetActiveConfigSection(section);
    if (artwork?.id) {
      const enableEnhancement = section === "jiffy-print-perfect";
      debouncedToggleEnhancement(artwork.id, enableEnhancement);
    }
    const trackPayloadData = {};
    if (section === "print-as-uploaded") {
      // @ts-expect-error TS(2339): Property 'enhancementTier' does not exist on type ... Remove this comment to see the full error message
      trackPayloadData.enhancementTier = null;
      // @ts-expect-error TS(2339): Property 'editType' does not exist on type '{}'.
      trackPayloadData.editType = "Print as uploaded";
    } else if (section === "jiffy-print-perfect") {
      // @ts-expect-error TS(2339): Property 'enhancementTier' does not exist on type ... Remove this comment to see the full error message
      trackPayloadData.enhancementTier = "PrintPerfect";
      // @ts-expect-error TS(2339): Property 'editType' does not exist on type '{}'.
      trackPayloadData.editType = "Jiffy Print Perfect";
    }
    trackRudderstackImageEdited({
      // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
      // eslint-disable-next-line no-nested-ternary
      product_line: store.sticker ? "sticker" : store.isProColor ? "pro color" : "dtf",
      artwork: {
        ...artwork,
        // @ts-expect-error TS(2339): Property 'enhancementTier' does not exist on type ... Remove this comment to see the full error message
        enhancementTier: trackPayloadData.enhancementTier
      },
      // @ts-expect-error TS(2339): Property 'editType' does not exist on type '{}'.
      edit_type: trackPayloadData.editType,
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworks_count: store.artworks.length,
      location: "pdp",
      // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
      pre_cut_transfers: store.preCut
    });
  }

  return (
    <div
      {...restProps}
      className={cn("artwork-quality-config-panel scope-f6116a9e", restProps.className)}
    >
      <div
        className={cn(
          "artwork-quality-config-panel__section scope-f6116a9e",
          (!artwork?.id || activeConfigSection === "jiffy-print-perfect") &&
            "artwork-quality-config-panel__section--active"
        )}
      >
        <button
          className="artwork-quality-config-panel__caption scope-f6116a9e"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setActiveConfigSection("jiffy-print-perfect");
          }}
          data-testid="artwork-quality-config-panel-caption"
        >
          <UseSvg
            className="artwork-quality-config-panel__caption-icon scope-f6116a9e"
            icon="checkmark-circled"
            data-testid="artwork-quality-config-panel-caption-icon"
          />
          <span className="scope-f6116a9e">Jiffy Print Perfect</span>
        </button>
        <div className="artwork-quality-config-panel__body scope-f6116a9e">
          <TrimInfo
            className="scope-f6116a9e"
            id={artwork.id}
            artwork={artwork}
            background={artwork.background}
            canRemoveBg={artwork.canRemoveBg}
            removeBackground={artwork.removeBackground}
            toggleBackgroundError={artwork.toggleBackgroundError}
            activeConfigSection={activeConfigSection}
            data-testid="trim-info"
          />
          {showRedrawNote() ? (
            <RedrawNotes
              className="scope-f6116a9e"
              enhancementNote={artwork.enhancementNote}
              index={index}
              data-testid="redraw-notes"
            />
          ) : null}
        </div>
      </div>
      <div
        className={cn(
          "artwork-quality-config-panel__section scope-f6116a9e",
          artwork?.id &&
            activeConfigSection === "print-as-uploaded" &&
            "artwork-quality-config-panel__section--active",
          isPrintAsUploadedDisabled() && "artwork-quality-config-panel__section--disabled"
        )}
      >
        <button
          className="artwork-quality-config-panel__caption scope-f6116a9e"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setActiveConfigSection("print-as-uploaded");
          }}
          data-testid="artwork-quality-config-panel-caption-1"
        >
          <UseSvg
            className="artwork-quality-config-panel__caption-icon scope-f6116a9e"
            icon="checkmark-circled"
            data-testid="artwork-quality-config-panel-caption-icon-1"
          />
          <span className="scope-f6116a9e">Print as uploaded</span>
        </button>
      </div>
    </div>
  );
}
